<section class="container bgWhite">
  <section class="col-md-12 col-sm-12 col-xs-12">
    <div class="manage-week">
      <form [formGroup]="fileExportForm">
        <h4>STS Order Export</h4>
        <p>Please select the formula to export the data</p>
        <div class="browse-btn-group">
          <div class="wrapper form-group">
            <ng-select name="timeFrame" [items]="seasonList" [searchable]="false" [clearable]="false" bindLabel="code"
              bindValue="code" class="dropdown-season" dropdownPosition="bottom" formControlName="seasoncode"
              placeholder="Select">
            </ng-select>
          </div>
        </div>
        <button type="button" class="btn btn-primary" (click)="exportExcel()"
          [disabled]="fileExportForm.invalid || !fileExportForm.get('seasoncode').value">Export to
          Excel</button>
      </form>
    </div>

  </section>
</section>